
import { URL_PATIENTS_PGD, URL_PROYECT, URL_SHOW_PROYECT } from 'routes/routes-constants'
import { Details } from 'features/common/pgd-pg-common/Details'

type DetailProps = {
  id?: string
}

export const Detail = (props: DetailProps) => {
  return <Details id={props.id} urlPatients={URL_PATIENTS_PGD} urlProyects={URL_PROYECT} urlShowProyect={URL_SHOW_PROYECT} pgType='pgd'/>
}